export const PAYMENT_STATUS = {
  notRequired:       { label: 'No Payment Required', color: '#34C759', icon: 'check_circle' },
  authorized:        { label: 'Authorized',        color: '#007AFF', icon: 'credit_card' },
  paid:              { label: 'Paid',               color: '#34C759', icon: 'check_circle' },
  failed:            { label: 'Failed',             color: '#FF3B30', icon: 'cancel' },
  pending:           { label: 'Pending',            color: '#FF9500', icon: 'schedule' },
  refunded:          { label: 'Refunded',           color: '#AF52DE', icon: 'replay' },
  partiallyRefunded: { label: 'Partially Refunded', color: '#007AFF', icon: 'replay' },
  disputed:          { label: 'Disputed',           color: '#FF3B30', icon: 'warning' },
};
